import { ReactNode } from 'react';

export enum tabType {
  CONFIG_APP = 'config',
  SECRET_KEY = 'secretKey',
}

export interface IBaseInput {
  key: string;
  title: string | ReactNode;
  val: string;
  placeholder: string;
  handleChange: any;
  submitted?: boolean;
  required?: boolean;
  isValidVal?: boolean;
}
